// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3e6Tk","alert":"SettungsInbox_alert__3IR0E"};